import type { NskResponse } from "~/models/Api";
import type { DealConstruction } from "~/models/DealConstruction";
import { postRequest } from "~/utils/api/api_handler";

const paths = {
	updateSeq: "/vendors/deals/:deal_id/deal_estimations/update_seq"
};

export const updateSeq = async (
	dealEstimations: DealConstruction[],
	dealId: number
): Promise<NskResponse> =>
	postRequest(paths.updateSeq.replace(":deal_id", String(dealId)), {
		dealEstimations
	});
